import React from 'react';
import { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { P } from '../../../AbstractElements';

const Footer = () => {
  return (
    <Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md="12" className="footer-copyright text-center">
            <div className="copyright">
                <p>
                  Made with  ❤️ by
                  <a target='_blank' href="https://fixingdots.com/">&nbsp;Fixing Dots</a>
                </p>
    </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </Fragment>
  );
};

export default Footer;